module.exports = __webpack_public_path__ + "img/downtime-dark.55f3279e.svg";